import React from "react";
import { Link } from "react-router-dom";

const Layout = ({ nav, children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <header className="bg-black">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-white">Tixy.az</Link>
          <nav className="flex gap-6">
            {nav}
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 bg-[#f5f3ee]">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-black">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <div>© {new Date().getFullYear()} Tixy.az Bütün hüquqlar qorunur.</div>
          <div className="flex gap-4 mb-4 md:mb-0">
            <Link to="/about" className="hover:text-white transition">Haqqımızda</Link>
            <Link to="/privacy-policy" className="hover:text-white transition">Məxfilik Siyasəti</Link>
            <a href="tel:+994556611161" className="hover:text-white transition">+994 55 661 1161</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
